/**
 * Ensures L is on window for leaflet.markercluster UMD bundle.
 * Import this before leaflet.markercluster.
 */
import * as L from 'leaflet';
(window as any).L = L;
